import React from 'react';
import { TIER } from './copy';

export function OffRampTierLegend() {
    return (
        <div className="flex flex-wrap gap-2 mt-3" role="list" aria-label="Result tier legend">
            <span
                role="listitem"
                title={TIER.deterministicHint}
                className="inline-flex items-center gap-1.5 px-2 py-1 text-[11px] rounded-md bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border border-emerald-500/20"
            >
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                {TIER.deterministic}
            </span>
            <span
                role="listitem"
                title={TIER.scoredHint}
                className="inline-flex items-center gap-1.5 px-2 py-1 text-[11px] rounded-md bg-amber-500/10 text-amber-700 dark:text-amber-400 border border-amber-500/20"
            >
                <span className="w-1.5 h-1.5 rounded-full bg-amber-500" />
                {TIER.scored}
            </span>
            <span
                role="listitem"
                title={TIER.boundaryHint}
                className="inline-flex items-center gap-1.5 px-2 py-1 text-[11px] rounded-md bg-secondary text-muted-foreground border border-border"
            >
                <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground" />
                {TIER.boundary}
            </span>
        </div>
    );
}
